import { cn } from '../../lib/cn.ts';

const spinnerClass =
  'inline-block size-4 animate-spin rounded-full border-2 border-current border-r-transparent';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  if (label) return <span role="status" aria-label={label} className={cn(spinnerClass, className)} />;
  return <span aria-hidden className={cn(spinnerClass, className)} />;
}
